import { Dialog, DialogActions, DialogContent, FormControl, } from "@mui/material";
import { useState } from "react";
import { Button, Form, PasswordInput, required, useDataProvider, useNotify } from "react-admin";

interface PasswordDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    title?: string;
    confirmLabel?: string;
}

// 创建自定义过滤器组件
const PasswordVerifiers = (props: PasswordDialogProps) => {
    const { open, onClose, onConfirm, title = "请输入管理员操作密码", confirmLabel = "确认" } = props;
    const [loading, setLoading] = useState(false);
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleConfirm = async (data: any) => {
        setLoading(true);
        try {
            await dataProvider.validatePassword({ password: data.password }).then(async (res: any) => {
                if (res.data) {
                    await onConfirm();
                    notify('操作成功', { type: 'success' });
                } else {
                    //表单提示:密码验证失败
                    notify('密码验证失败', { type: 'error' });
                }
            }).catch((err: any) => {
                //表单提示:密码验证失败
                notify('密码验证失败', { type: 'error' });
            })
        } catch (error: any) {
            //表单提示:操作失败
            notify(`操作失败: ${error.message}`, { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <Form onSubmit={handleConfirm}>
                <DialogContent sx={{ width: '400px' }}>
                    <FormControl fullWidth margin="normal">
                        <PasswordInput
                            autoFocus
                            margin="dense"
                            label={title}
                            source="password"
                            validate={[required()]}
                            fullWidth
                            variant="standard"
                            disabled={loading}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={loading}>取消</Button>
                    <Button
                        type="submit"
                        color="primary"
                        disabled={loading}
                    >
                        {confirmLabel}
                    </Button>
                </DialogActions>
            </Form>
        </Dialog>
    );
};

export default PasswordVerifiers;